module.exports = __webpack_public_path__ + "static/media/34.ce45582f.jpg";